import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("rc_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
